
























































import { Component, Vue } from "vue-property-decorator";
import UserApi from "@/api/userApi";
// import AuthModule from "@/store/modules/auth";
import { namespace } from "vuex-class";
import { USER_TYPE } from "@/model/user";
import Company from "@/model/company";
import defineAbilityFor from "@/services/ability";
import store from "@/store";
import { CONTRACT_CUSTOMER_CONFIRM } from "@/model/contract";
import UserCompany from "@/model/userCompany";

const auth = namespace("Auth");
@Component({
  name: "Login",
  components: {},
})
export default class Login extends Vue {
  @auth.Action
  updateToken!: (token: string) => void;
  @auth.Action
  updateExpiredAt!: (time: string) => void;
  @auth.Action
  updateRole!: (role: string) => void;
  @auth.Action
  fetchCurrentUser!: () => void;
  @auth.Action
  setUserType!: (type: number) => void;
  @auth.Action
  setCompanyLinked!: (companies: Company[]) => void;
  @auth.Action
  setUserCompanies!: (userCompanies: UserCompany[]) => void;

  form = {
    email: "",
    password: "",
  };
  errorMessage = "";

  public state = 1;

  public companies: Company[] = [];

  async login(): Promise<void> {
    const result = await UserApi.login(this.form);
    if (result.meta.status === 200) {
      const data = result.data;
      this.updateToken(result.meta.token);
      this.setUserType(data.type);
      // if role admin navigate to dashboard
      await this.fetchCurrentUser();
      if (data.type === USER_TYPE.STAFF) {
        // multiple groups
        const companyList = data.companies.map((item) => new Company(item));
        const userCompanies = data.user_companies.map((item) => new UserCompany(item));

        if (data.user_companies && data.user_companies.length > 1) {
          this.setCompanyLinked(companyList);
          this.setUserCompanies(userCompanies);
          this.$router.push({ name: "select-company" });
        } else {
          this.setCompanyLinked(companyList);
          this.setUserCompanies(userCompanies);
          this.$ability.update(defineAbilityFor(this.$store.state.Auth.userLogging.type, userCompanies[0].role_id).rules);
          store.dispatch("Auth/setUsingCompany", userCompanies[0].id);
          this.$router.push({ name: "admin.dashboard" });
        }
      } else if(data.type === USER_TYPE.CUSTOMER) {
        store.dispatch("Auth/setUsingCompany", "");
        this.$ability.update(defineAbilityFor(this.$store.state.Auth.userLogging.type).rules);
        // check contract not confirm then swith to
        store.dispatch("Auth/setUsingContract", data.customer_contracts[0].id);
        if (data.customer_contracts[0].is_confirmed === CONTRACT_CUSTOMER_CONFIRM.WAIT) {
          this.$router.push({ name: "step.intro" });
        } else {
          this.$router.push({ name: "customer.home" });
        }
      }
    } else {
      this.errorMessage = result.meta.message;
    }
  }
}
